import React, { forwardRef } from 'react';

import useClasses from '../../../hooks/useClasses';
import type { Registrations } from '../../../types';
import BarGraphWeekOverviewWeek from '../BarGraphWeekOverview';

interface Props {
  registrationsGroupedByWeek: Registrations[];
  highestAmountOrGoal: number;
  currentWeekNumber: number;
  weeksBeforeProgramStartDate: number[];
  readonly?: boolean;
  isLoading?: boolean;
}

const BarGraphOverview = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    registrationsGroupedByWeek,
    highestAmountOrGoal,
    currentWeekNumber,
    weeksBeforeProgramStartDate,
    readonly,
    isLoading,
  } = props;

  const { buildClass } = useClasses('BarGraphOverview');

  return (
    <div className={buildClass()}>
      {registrationsGroupedByWeek.map((registrationsForWeek, index) => (
        <BarGraphWeekOverviewWeek
          ref={ref}
          key={`registration_week_${index + 1}`}
          registrations={registrationsForWeek}
          weekNumber={index - weeksBeforeProgramStartDate.length + 1}
          highestAmount={highestAmountOrGoal}
          readonly={readonly}
          isLoading={isLoading}
          hideGoalMessage={readonly}
          isCurrentWeek={index - weeksBeforeProgramStartDate.length + 1 === currentWeekNumber}
          hideTitle={weeksBeforeProgramStartDate.includes(index + 1)}
          currentWeekNumber={currentWeekNumber}
        />
      ))}
    </div>
  );
});

export default BarGraphOverview;
